import {Directive} from '@angular/core';

@Directive({
    selector: '[fui-table-header-title]'
})
export class TableHeaderTitleDirective {
}
